import { Metric } from "./AdminShared";

export function AdminMetricsTiles({ metrics }) {
  return (
    <>
      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3">
        <Metric
          label="Registered users"
          value={metrics.users.total}
          hint={`${metrics.users.admins} admin`}
          testId="admin-metric-users"
        />
        <Metric
          label="Logged-in users"
          value={metrics.users.logged_in}
          hint="≥1 analysis"
          testId="admin-metric-logged-in-users"
        />
        <Metric
          label="Repeat users"
          value={metrics.users.repeat}
          hint="≥2 analyses"
          testId="admin-metric-repeat-users"
        />
        <Metric
          label="Total analyses"
          value={metrics.incidents.total}
          testId="admin-metric-total"
        />
        <Metric
          label="Anonymous"
          value={metrics.incidents.anonymous}
          hint="no saved history"
          testId="admin-metric-anonymous"
        />
        <Metric
          label="Logged-in"
          value={metrics.incidents.authenticated}
          hint="7-day retention"
          testId="admin-metric-authenticated"
        />
        <Metric
          label="Pending approval"
          value={metrics.incidents.pending_approval}
          hint={`${metrics.incidents.approved} approved · ${metrics.incidents.rejected} rejected`}
          testId="admin-metric-pending-approval"
        />
      </div>

      {/* Plan + billing tiles */}
      <div
        className="mt-4 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3"
        data-testid="admin-billing-tiles"
      >
        <Metric
          label="Free users"
          value={metrics.users?.free ?? 0}
          hint={`${metrics.users?.free_at_limit ?? 0} at limit`}
          testId="admin-metric-free-users"
        />
        <Metric
          label="Pro users"
          value={metrics.users?.pro ?? 0}
          hint={`${metrics.users?.pro_at_limit ?? 0} at limit`}
          testId="admin-metric-pro-users"
        />
        <Metric
          label="Active subs"
          value={metrics.billing?.active_subscriptions ?? 0}
          hint={`${metrics.billing?.cancelled_subscriptions ?? 0} cancelled`}
          testId="admin-metric-active-subs"
        />
        <Metric
          label="Billing warnings"
          value={metrics.billing?.billing_warnings ?? 0}
          hint="payment failed"
          testId="admin-metric-billing-warnings"
        />
        <Metric
          label="Analyses today"
          value={metrics.usage?.used_today ?? 0}
          hint={`${metrics.usage?.used_this_month ?? 0} this month`}
          testId="admin-metric-analyses-today"
        />
        <Metric
          label="Pro · India"
          value={metrics.billing?.india_pro_users ?? 0}
          hint={`₹${(metrics.billing?.estimated_revenue_inr ?? 0).toLocaleString()}/mo`}
          testId="admin-metric-pro-india"
        />
        <Metric
          label="Pro · Other"
          value={metrics.billing?.other_pro_users ?? 0}
          hint={`£${(metrics.billing?.estimated_revenue_gbp ?? 0).toLocaleString()}/mo`}
          testId="admin-metric-pro-other"
        />
      </div>
    </>
  );
}
